import { render, staticRenderFns } from "./ClientMessageView.vue?vue&type=template&id=66dbf494"
import script from "./ClientMessageView.vue?vue&type=script&lang=js"
export * from "./ClientMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports